/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchDetailsMovie } from "../../store/details/actions";
import LoadingIndicator from "../loadingIndicator/loadingIndicator";
import ErrorBoundry from "../errorBoundry/errorBoundry";
import Details from "../details/details";

const DetailsContainer = ({
  idMovie,
  details,
  error,
  loading,
  fetchDetails
}) => {
  useEffect(() => {
    fetchDetails(idMovie);
  }, [idMovie]);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorBoundry />;
  }

  return <Details details={details} />;
};

const mapState = state => {
  return {
    details: state.details.movieDetails,
    loading: state.details.loading,
    error: state.details.error
  };
};

const mapDispatch = dispatch => {
  return {
    fetchDetails: id => fetchDetailsMovie(dispatch, id)
  };
};

export default connect(mapState, mapDispatch)(DetailsContainer);
